<template>

    <section>
        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalDeleteWithPromise
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container confirm DeleteConf" :class="classObject">
            <div class="modal_wrap">

                <!-- Title -->
                <div class="modal_title">
                    <h3><span>{{title}}</span></h3>
                </div>

                <!-- Body -->
                <div class="modal_body">
                    <div class="inner">
                        <p>{{message}}</p>
                    </div>
                </div>

                <!--btn-link-wrap-->
                <div class="btn_link-wrap">

                    <button class="btn_link _cancel md_icon-text js-modal-close" @click="onCancel">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                        </div>
                    </button>

                    <button v-if="mode=='delete'" class="btn_link md_icon-text _white js-modal-close" :class="classObject" @click="onConfirm">
                        <div class="inner">
                            <span><div class="icon"><SvgIconDelete/></div>削除</span>
                        </div>
                    </button>

                    <button v-if="mode=='confirm'" class="btn_link md_icon-text _white" @click="onConfirm">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>OK</span>
                        </div>
                    </button>

                </div><!--/.btn-link-wrap-->

            </div>
            <div class="modal_close-ovl js-modal-close"></div>
        </div>
    </section>

</template>


<script>

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            //Svg
            SvgIconCheck,
            SvgIconCancel,
            SvgIconDelete
        },
        data() {
            return {
                resolvePromise: undefined,
                rejectPromise: undefined,
                title: String,
                message: String,
                mode: String,
                name: String
            }
        },
        computed: {
            classObject() {
                let allClassObject = {'_delete': this.mode === "delete"};
                allClassObject[this.name] = this.name; 
                return allClassObject;
            },
        },
        methods: {
            show(opts = {}) {
                this.title = opts.title;
                this.message = opts.message;
                this.mode = opts.mode;
                this.name = opts.name;
                setTimeout(this.coolOpen, 200);    
                return new Promise((resolve, reject) => {
                    this.resolvePromise = resolve;
                    this.rejectPromise = reject;
                })
            },
            onCancel(){
                this.resolvePromise(false);
                this.coolClose();
            },
            onConfirm(){
                this.resolvePromise(true);
                this.coolClose();
            },
            coolOpen(){
                $(`.modal_container.confirm.${this.name}`).addClass('_open');
                $('.modal_bg').addClass('_on');
            },
            coolClose(){
                $(`.modal_container.confirm.${this.name}`).removeClass('_open');
                $('.modal_bg').removeClass('_on');
            }
        }
    }
</script>